import {css, html} from '@isceco/widget-library2/external/lit'
import '@isceco/widget-library2/basic-elements/Title/Title'
import '@isceco/widget-library2/basic-elements/Button/Button'
import '@isceco/widget-library2/basic-elements/Form/Form'
import '@isceco/widget-library2/basic-elements/TextInput/TextInput'
import '@isceco/widget-library2/basic-elements/DateInput/DateInput'
import '@isceco/widget-library2/basic-elements/Switch/Switch'
import '@isceco/widget-library2/basic-elements/NumberInput/NumberInput'
import '@isceco/widget-library2/basic-elements/FileInput/FileInput'
import TestformularService from "./TestformularService"
import FormComponent from "../../../../components/FormComponent";

export default class Testformular extends FormComponent {

  get translationFile() {
    return './views/WBF/ISCeco/Testformular/i18n.json'
  }

  connectedCallback() {
    super.connectedCallback()
    this.reload()
  }

  get css() {
    return css`
      #attachments {
        margin-top: var(--isceco-space-300);
        margin-bottom: var(--isceco-space-300);
      }
    `
  }

  getTemplate() {
    const submitKey = this.preview ? 'form.button.submit' : 'form.button.preview'
    return html`
      <isceco-title id="page-title"
                    text="${this.i18n.translate('page.title')}"
      ></isceco-title>
      <eform-submit-status></eform-submit-status>
      <isceco-form id="testformular-form"
                   include-disabled
                   submit-button-text="${this.i18n.translate(submitKey)}"
                   @submit="${e => this._submit(e)}">

        <div slot="buttons">
          <isceco-button text="${this.i18n.translate('form.button.abort')}"
                         @click="${() => this.abort()}"
                         variant="secondary"
                         .disabled="${!this.preview}"
          ></isceco-button>
        </div>

        <div slot="form-elements" class="form-elements">
          ${this.getFormElements()}
        </div>
      </isceco-form>
    `
  }

  getFormElements = () => {
    return html`
        <div slot="form-elements" class="form">
          <isceco-text-input label="${this.i18n.translate('form.input.text')}"
                             name="text"
                             required
                             .readonly="${this.preview}"
          ></isceco-text-input>
          <isceco-date-input label="${this.i18n.translate('form.input.date')}"
                             name="date"
                             .readonly="${this.preview}"
          ></isceco-date-input>
          <isceco-switch label="${this.i18n.translate('form.input.flag')}"
                         name="flag"
                         .readonly="${this.preview}"
          ></isceco-switch>
          <isceco-number-input label="${this.i18n.translate('form.input.number')}"
                               name="number"
                               maximum-fraction-digits="0"
                               .readonly="${this.preview}"
          ></isceco-number-input>
          <isceco-text-input label="${this.i18n.translate('form.input.referenz')}"
                             name="referenz"
                             .readonly="${this.preview}"
          ></isceco-text-input>
          <div id="attachments">
            <isceco-file-input label="${this.i18n.translate('form.input.attachment')}"
                               name="attachments"
                               multiple
                               maxfiles="25"
                               maxsize="${this.fileMaxSize}"
                               .fileInputService="${this.fileInputService}"
                               .disabled="${this.preview}"
            ></isceco-file-input>
          </div>
        </div>
    `
  }

  _submit = event => {
    if (!this.preview) {
      this.preview = true
      this.render()
      return
    }

    new TestformularService().submit(event.detail, event.target)
  }
}
customElements.define('eform-frontend-wbf-isceco-testformular', Testformular)
